"use strict";

import React, {Component} from "react";
import PropTypes from "prop-types";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class ViolationLevelIcon extends Component {

    static defaultProps = {
        size: "1x",
    };

    static propTypes = {
        enrichedVideo: PropTypes.object.isRequired,
        size: PropTypes.string,
    };

    constructor(props) {
        super(props);
    }

    hasViolation(enrichedVideo) {
        return enrichedVideo.errorViolation || enrichedVideo.warningViolation || enrichedVideo.infoViolation || enrichedVideo.unknownViolation;
    }

    violationLevelIconfrom(enrichedVideo) {
        if (enrichedVideo.errorViolation) {
            return "ban";
        } else if (enrichedVideo.warningViolation) {
            return "exclamation-triangle";
        } else if (enrichedVideo.infoViolation) {
            return "info-circle";
        } else if (enrichedVideo.unknownViolation) {
            return "question-circle";
        }
    }

    violationLevelClassFrom(enrichedVideo) {
        if (enrichedVideo.errorViolation) {
            return "text-red";
        } else if (enrichedVideo.warningViolation) {
            return "text-yellow";
        } else if (enrichedVideo.infoViolation) {
            return "text-light-blue";
        } else if (enrichedVideo.unknownViolation) {
            return "text-muted";
        }
    }

    renderViolationLevelIcon() {
        const { enrichedVideo, size } = this.props;

        return this.hasViolation(enrichedVideo)
               ? <FontAwesomeIcon icon={ this.violationLevelIconfrom(enrichedVideo) }
                                  fixedWidth={true}
                                  size={ size }
                                  className={ this.violationLevelClassFrom(enrichedVideo) }/>
               : null;

    }

    render() {
        return (
            this.renderViolationLevelIcon()
        );
    }

}

export default ViolationLevelIcon;